export const getMainDomain = (hostname: string): string => {
  if (process.env.NODE_ENV === 'development') {
    return hostname;
  }

  return hostname.split('.').splice(-2).join('.');
};
